export default "__VITE_ASSET__DOhNn1li__"